var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "dp-mainbody dp-main-section",
        class: { expanded: _vm.expanded }
      },
      [
        _c("div", { staticClass: "b-paragraph-l dp-mainbody-content" }, [
          _c("header", { staticClass: "b-readable-l b-vspace-m title" }, [
            _c("h3", { staticClass: "b-title-meta" }, [
              _vm._v(_vm._s(_vm.dailyChallenge.track))
            ]),
            _vm._v(" "),
            _vm.isSeries
              ? _c("div", { staticClass: "footer" }, [
                  _c("span", { staticClass: "series" }, [
                    _c("span", [_vm._v("Series")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.dailyChallenge.series.position) +
                        " of " +
                        _vm._s(_vm.dailyChallenge.series.total) +
                        "\n          "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dp-title-group" },
              [
                _c("h2", { staticClass: "b-title-section" }, [
                  _vm._v(_vm._s(_vm.dailyChallenge.title))
                ]),
                _vm._v(" "),
                this.problem.xp_value && !_vm.isCompleted
                  ? _c("XPBadge", {
                      staticClass: "dc-xp-badge",
                      attrs: { xp: this.problem.xp_value }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dp-mainbody-text" }, [
            _c("div", { staticClass: "b-readable-l" }, [
              _c("div", { staticClass: "head b-vspace-m" }, [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.processedMainbodyHead) }
                }),
                _vm._v(" "),
                _vm.alwaysFullVisible
                  ? _c("div", {
                      staticClass: "is-processed",
                      domProps: { innerHTML: _vm._s(_vm.processedMainbodyTail) }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.showFeaturedCourse
                ? _c(
                    "div",
                    { staticClass: "inline-featured-course" },
                    [
                      _vm.showFeaturedCourse
                        ? _c("DailyChallengeFeaturedCourse", {
                            staticClass: "embedded-featured-course"
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isLocked & !_vm.alwaysFullVisible
                ? _c("div", { staticClass: "tail" }, [
                    _c("div", {
                      staticClass: "is-processed",
                      domProps: { innerHTML: _vm._s(_vm.processedMainbodyTail) }
                    })
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "footer",
              { class: ["expand-footer", { "no-button": _vm.isLocked }] },
              [
                !_vm.isLocked & !_vm.alwaysFullVisible
                  ? _c("div", { staticClass: "b-readable-l" }, [
                      _c("div", { staticClass: "b-vspace-m" }, [
                        !_vm.isLocked
                          ? _c(
                              "button",
                              {
                                staticClass: "btn-link ax-click",
                                attrs: { id: "dp-expand" },
                                on: { click: _vm.keepReading }
                              },
                              [
                                _vm._v(
                                  "\n                Keep reading\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }